module.exports = __webpack_public_path__ + "static/img/l1.008f9fa1.png";